import Pages from "./Pages";
import Chapter01 from "../../media/AllSkiesChapters/Chapter01";
import Chapter02 from "../../media/AllSkiesChapters/Chapter02";
import { useEffect, useRef, useState } from "react";
import { PageAnalytics } from "../../utils/types";
import "../../Styles/Button.css";
import "../../Styles/Containers.css";

type updateType = 1 | -1;

const AllSkiesPage: React.FC<PageAnalytics> = (props: PageAnalytics) => {
  const { fireKit } = props;

  useEffect(() => {
    fireKit.logEvent(fireKit.analytics, "view_allskies");
  }, []);

  const AllChapters = [Chapter01, Chapter02];
  const [currentChapter, setCurrentChapter] = useState(Chapter01);
  const firstChapter = AllChapters[0];
  const lastChapter = AllChapters[AllChapters.length - 1];
  const windowSize = useRef([window.innerWidth, window.innerHeight]);

  const updateChapter = (update: updateType) => {
    window.scrollTo(0, 0);
    setCurrentChapter(
      AllChapters[AllChapters.indexOf(currentChapter) + update]
    );
  };

  return (
    <div className="centerContainer">
      <Pages CHAPTER={currentChapter} fireKit={fireKit} />

      {/* CHAPTER NAVIGATOR */}
      <div
        style={
          windowSize.current[0] > 1023
            ? {
                display: "flex",
                justifyContent: "center",
                alignContent: "center",
                width: "40em",
                height: "10em",
              }
            : {
                display: "flex",
                justifyContent: "center",
                alignContent: "center",
                width: "4em",
                height: "3em",
              }
        }
      >
        {currentChapter !== firstChapter && (
          <button
            className="button-85"
            onClick={() => {
              updateChapter(-1);
            }}
          >
            <div
              className="centerContainer"
              style={
                windowSize.current[0] > 1023
                  ? {
                      fontSize: "30px",
                      fontWeight: "bold",
                    }
                  : {
                      fontSize: "12px",
                      fontWeight: "bold",
                    }
              }
            >
              <text>Anterior</text>
              <text>Capítulo</text>
            </div>
          </button>
        )}
        {currentChapter !== lastChapter && (
          <button
            className="button-85"
            style={
              windowSize.current[0] > 1023
                ? {
                    fontSize: "30px",
                    fontWeight: "bold",
                  }
                : {
                    fontSize: "12px",
                    fontWeight: "bold",
                  }
            }
            onClick={() => {
              updateChapter(1);
            }}
          >
            <div className="centerContainer">
              <text>Próximo</text>
              <text>Capítulo</text>
            </div>
          </button>
        )}
      </div>
    </div>
  );
};

export default AllSkiesPage;
